import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Renderer2, Input } from '@angular/core';

import { GetCountryTimezoneService } from '../services/get-country-timezone.service';
import { GoogleAddressValidateService } from '../services/google-address-validate.service';
import { CommonUtil } from '../Utils/common-util';

import { RootScopeService } from '../shared-service/root-scope.service';
import { RootScopeDeclare } from '../rootscope-declare';
import { environment } from '../../../environments/environment';
import { FacilityService } from '../services/facility.service';
import { HaloToastService, EToastType } from '../halo-toast/halo-toast.service';
import { HaloLoaderService } from '../halo-loader/halo-loader.service';
import { Router } from '@angular/router';
import { MultiFacilityService } from 'src/app/post-login/services/multi-facility.service';

interface IcountrytimeZoneResponse {
  id: string;
  isoCountryCode: string;
  name: string;
  timezoneList: ITimezoneObj[];
}

interface ITimezoneObj {
  name: string;
  timezone: string;
}

declare var $: any;
@Component({
  selector: 'app-facility-information',
  templateUrl: './facility-information.component.html',
  styleUrls: ['./facility-information.component.scss'],
})
export class FacilityInformationComponent implements OnInit {
  // @ViewChild('facilityInfoCntr', { static: false }) facilityInfoCntrElem: ElementRef;
  @ViewChild('address', { static: false }) addressElem: ElementRef;
  @ViewChild('city', { static: false }) cityElem: ElementRef;
  @ViewChild('state', { static: false }) stateElem: ElementRef;
  @ViewChild('zip', { static: false }) zipElem: ElementRef;
  @ViewChild('stateLbl', { static: false }) stateLblElem: ElementRef;
  @ViewChild('zipLbl', { static: false }) zipLblElem: ElementRef;
  @ViewChild('stateCntr', { static: false }) stateCntrElem: ElementRef;
  @ViewChild('stateError', { static: false }) stateErrorElem: ElementRef;
  @ViewChild('zipError', { static: false }) zipErrorElem: ElementRef;

  @Input() action?: string;
  @Input() facilityInformation: any;
  @Output() nextBtnClickOnStep2: EventEmitter<string> = new EventEmitter();
  @Output() backBtnClickOnStep2: EventEmitter<string> = new EventEmitter();
  @Output() step2Values: EventEmitter<object> = new EventEmitter();
  @Output() cancelBtnClickOnStep2: EventEmitter<string> = new EventEmitter();

  rootScopeData: RootScopeDeclare;
  facilityName: string;
  facilityId: number;
  facilityType: string;
  facilityTypeList: any;
  iAccept: boolean;
  googleValidatedAddressStatus: number;
  googleAddressSuggestions = [];
  selectedTimezone: string;
  countryTimezoneList: IcountrytimeZoneResponse[] = [];
  timezoneList: ITimezoneObj[] = [];
  countryId: string;
  city: string;
  zip: string;
  phoneNumber: string;
  selectedCountryCode: string;
  displayTimezone: string;
  countryName: string;
  displayFacilityType: string;
  isConnected: boolean;
  addressFieldJsonPath: string;
  facilityMaxCountMsg: string;
  facilityNameErrorMsg: string;
  facilityTypeErrorMsg: string;
  facilityCountryErrorMsg: string;
  facilityTimezoneErrorMsg: string;
  facilityAddressErrorMsg: string;
  facilityCityErrorMsg: string;
  facilityContactNumberErrorMsg: string;
  hasEditFacPerm: boolean;
  isAddreesApprovedByUser: boolean;
  addressToMap: string;
  facilityInfoErrors: any = {};
  zipFormat: string;
  isAddressConfirmed: boolean;
  initialAddress: any = {};
  isFacilityForm: boolean = false;
  openTime: string = '00:00';
  closeTime: string = '24:00';
  openFacTime: { facilityHours: number; facilityMins: number };
  closeFacTime: { facilityHours: number; facilityMins: number };
  deleteFacilityPopupProperties: any = {};
  errorFacilityPopupProperties: any = {};
  showDeleteFacilityModal: boolean = false;
  showErrorFacilityModal: boolean = false;
  isDeleteMultiFacility: boolean = false;
  addressSample: any;
  openTimeDisableController: string = '';
  closeTimeDisableController: string = '';
  facilityOperationHourBefore: boolean = false;
  facilityOperationHourSame: boolean = false;
  _manualCountryChange: boolean = false;
  deleteText: string = '';
  currentHostPath: string = '';
  isDeleteAvailable: boolean = false;
  isClickedOnCloseTime = false;

  constructor(
    private getCountryTimezoneService: GetCountryTimezoneService,
    private googleAddressValidateService: GoogleAddressValidateService,
    private commonUtil: CommonUtil,
    private rootScopeService: RootScopeService,
    private rendererObj: Renderer2,
    private _facilityService: FacilityService,
    private multiFacService: MultiFacilityService,
    private loader: HaloLoaderService,
    private toast: HaloToastService,
    private router: Router
  ) {
    this.getRootScopeData();
  }

  ngOnInit() {
    this.isFacilityForm = !!this.action;
    this.currentHostPath = environment.currentHostPath;
    this.getCountryTimezoneList();
    this.constructFacilityTypeList();
    this.constructErrorMessages();
    this.initFacilityForm();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  constructFacilityTypeList(): void {
    this.facilityTypeList = [
      { id: '1', key: 'ATHLETICS' },
      { id: '2', key: 'COLLEGE.UNIVERSITY' },
      { id: '3', key: 'CORPORATE.WELLNESS' },
      { id: '4', key: 'HEALTH.CLUBS' },
      { id: '5', key: 'HOSPITALITY' },
      { id: '6', key: 'MILITARY.AND.FEDERAL.GOVERNMENT' },
      { id: '7', key: 'MULTI.UNIT.RESIDENTIAL' },
      { id: '8', key: 'HOME' },
      { id: '9', key: 'OTHERS' },
    ];
    this.facilityType = 'null';
    this.isAddressConfirmed = false;
    this.isAddreesApprovedByUser = false;
    this.hasEditFacPerm = true;
    this.googleValidatedAddressStatus = 0;
    this.isConnected = false;
    this.deleteText = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.NO', [
      this.commonUtil.translateText('FP.USERPROFILE.LBL.LOCATION'),
    ]);
    //this.displayFacilityType = this.commonUtil.translateText(this.facilityTypeList[0].key);
  }

  constructErrorMessages(): void {
    this.facilityMaxCountMsg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('MAX.COUNT.CHARACTERS', ['50']);
    this.facilityNameErrorMsg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER', [
      this.commonUtil.translateText('NAME').toLowerCase(),
    ]);
    this.facilityTypeErrorMsg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.SELECT', [
      this.commonUtil.translateText('FACILITY.TYPE').toLowerCase(),
    ]);
    this.facilityCountryErrorMsg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.SELECT', [
      this.commonUtil.translateText('COUNTRY').toLowerCase(),
    ]);
    this.facilityTimezoneErrorMsg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.SELECT', [
      this.commonUtil.translateText('TIME.ZONE').toLowerCase(),
    ]);
    this.facilityAddressErrorMsg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER', [
      this.commonUtil.translateText('ADDRESS').toLowerCase(),
    ]);
    this.facilityCityErrorMsg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER', [
      this.commonUtil.translateText('CITY').toLowerCase(),
    ]);
    this.facilityContactNumberErrorMsg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER', [
      this.commonUtil.translateText('CONTACT.NUMBER').toLowerCase(),
    ]);
  }

  checkPrepopulateFacilityInfo(): void {
    if (this.facilityInformation) {
      this.facilityName = this.facilityInformation.facilityName
        ? this.facilityInformation.facilityName
        : this.facilityInformation.ipAddress;
      this.facilityId = this.facilityInformation.facilityId;
      this.facilityType = this.facilityInformation.facilityType;
      this.changeFacilityType();
      this.phoneNumber = this.facilityInformation.phoneNumber;
      this.selectedCountryCode = this.facilityInformation.countryIsoCode;
      this.selectedTimezone = this.facilityInformation.timezone;
      this.populateTimezone(this.facilityInformation.countryIsoCode, false);
      this.isConnected = this.facilityInformation.isConnected === 'true' ? true : false;
      if (this.facilityInformation.userRights.facility == 'V') {
        this.hasEditFacPerm = false;
      }
    }
  }

  changeFacilityType(isChange: boolean = false): void {
    for (const i in this.facilityTypeList) {
      if (this.facilityType === this.facilityTypeList[i].id) {
        this.displayFacilityType = this.commonUtil.translateText(this.facilityTypeList[i].key);
      }
    }

    if(isChange) this.rootScopeData.isPageHasUnsavedChanges = true;
  }

  getCountryTimezoneList(): void {
    this.getCountryTimezoneService.getCountryTimezoneList().subscribe((data: any) => {
      this.countryTimezoneList = data.countryTimezone;
      this.selectDefaultOrSelectedCountry();
      this.enableAddressField();
      this.checkPrepopulateFacilityInfo();
    });
  }

  populateTimezone(countryCode: string, manualChange: boolean): void {
    this._manualCountryChange = manualChange;
    if(manualChange) this.rootScopeData.isPageHasUnsavedChanges = true;
    for (const i in this.countryTimezoneList) {
      if (this.countryTimezoneList[i].isoCountryCode === countryCode) {
        this.timezoneList = this.countryTimezoneList[i].timezoneList;
        // this.selectedTimezone = this.timezoneList[0].timezone;
        // this.displayTimezone = this.timezoneList[0].name;
        if (this.selectedTimezone && !manualChange) {
          const timezones = this.timezoneList.filter((tz) => tz.timezone === this.selectedTimezone);
          if (timezones.length) {
            this.selectedTimezone = this.facilityInformation.timezone;
          } else {
            this.selectedTimezone = 'null';
            this.displayTimezone = 'Select';
          }
        } else {
          this.selectedTimezone = 'null';
          this.displayTimezone = 'Select';
        }
        this.countryName = this.countryTimezoneList[i].name;
        this.countryId = this.countryTimezoneList[i].id;
        break;
      }
    }
    // this.selectedTimezone = 'null';
  }

  changeTimeZone(isChange: boolean = false): void {
    if(isChange) this.rootScopeData.isPageHasUnsavedChanges = true;
    for (const i in this.timezoneList) {
      if (this.selectedTimezone === this.timezoneList[i].timezone) {
        this.displayTimezone = this.timezoneList[i].name;
      }
    }
  }

  selectDefaultOrSelectedCountry(): void {
    if (!this.facilityInformation) {
      this.selectedCountryCode = 'US';
      this.populateTimezone(this.selectedCountryCode, false);
      this.selectedTimezone = 'null';
    }
  }

  enableAddressField(): void {
    this.addressFieldJsonPath = environment.assetsPath + '/js/addressfield.min.json';
    $('.facilityInfoCntr').addressfield({
      json: this.addressFieldJsonPath,
      fields: {
        country: '#country',
        thoroughfare: '#address',
        localityname: '#city',
        administrativearea: '#state',
        postalcode: '#zip',
      },
    });
    this.zipFormat = '';
    const facilityComp = this;
    const comUtil = this.commonUtil;
    $.fn.addressfield.validate = function (_field: HTMLElement, config: any) {
      if (typeof config != 'undefined') {
        if (config.hasOwnProperty('format')) {
          facilityComp.zipFormat = config.format;
        } else {
          facilityComp.zipFormat = '';
        }
        /*STATE DROPDOWN CHANGES START*/
        if (
          config.label == 'STATE' ||
          config.label == 'DISTRICT' ||
          config.label == 'AREA' ||
          config.label == 'COUNTY' ||
          config.label == 'DEPARTMENT' ||
          config.label == 'EMIRATE' ||
          config.label == 'GOVERNORATE' ||
          config.label == 'ISLAND' ||
          config.label == 'PARISH' ||
          config.label == 'PREFECTURE' ||
          config.label == 'PROVINCE' ||
          config.label == 'REGION'
        ) {
          facilityComp.initializeStateDropdown();
          facilityComp.initializeStateInputInJquery();
          if (typeof config.options != 'undefined' && typeof config.options.length != 'undefined') {
            facilityComp.populateErrorText('state');
            facilityComp.addSelectOptionInJquery();
          }
        }
        //if information is already there START
        if (facilityComp.facilityInformation) {
          if (facilityComp.facilityInformation.timezone && !this._manualCountryChange) {
            facilityComp.selectTimeZone(facilityComp.facilityInformation.timezone);
          }
          if (facilityComp.facilityInformation.state) {
            facilityComp.populateStateInJquery(facilityComp.facilityInformation.state);
          }
          facilityComp.populateOtherAddressFields(facilityComp.facilityInformation);
        }
        //if information is already there END
        if (
          config.label == 'ZIP.CODE' ||
          config.label == 'POST.CODE' ||
          config.label == 'POSTAL.CODE' ||
          config.label == 'PIN.CODE'
        ) {
          facilityComp.populateErrorText('zip');
          // let zipLbl = $("#zipLbl").text();
          // $("#zipError").text(comUtil.translateText('PLEASE.ENTER').replace('#', (comUtil.translateText(zipLbl))));
        }
      }
    };
  }

  populateErrorText(ele: string): void {
    if (ele == 'state') {
      let lblValue = this.stateLblElem.nativeElement.innerText;
      const selectText = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.SELECT', [
        this.commonUtil.translateText(lblValue).toLowerCase(),
      ]);
      this.rendererObj.setProperty(this.stateErrorElem.nativeElement, 'innerText', selectText);
      this.rendererObj.addClass(this.stateCntrElem.nativeElement, 'selectCntr');
    } else {
      let zipLblValue = this.zipLblElem.nativeElement.innerText;
      const selectText = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER', [
        this.commonUtil.translateText(zipLblValue).toLowerCase(),
      ]);
      this.rendererObj.setProperty(this.zipErrorElem.nativeElement, 'innerText', selectText);
    }
    /*
    const option = this.rendererObj.createElement('option');
    const defaultTextElem = this.rendererObj.createText(this.commonUtil.translateText('SELECT.ONE'));
    this.rendererObj.appendChild(option, document.createTextNode(defaultTextElem));
    this.rendererObj.appendChild(this.stateElem.nativeElement, option);
    */
  }

  addSelectOptionInJquery(): void {
    let stateElem = this.stateElem.nativeElement;
    let newOption =
      "<option value='null' selected disabled hidden>" + this.commonUtil.translateText('SELECT.ONE') + '</option>';
    $('select#state').addClass('ddWithPlaceHolder');
    $('select#state').removeClass('withValue');
    $('select#state').prepend(newOption);
    $('select#state').attr('required', 'required');
    $('select#state').change(function (this: any) {
      stateElem.value = $(this).val();
      if ($(this).val() == 'null' || $(this).val() == '') {
        $(this).removeClass('withValue');
      } else {
        $(this).addClass('withValue');
      }
    });
    $('select#state option').each(function (this: any) {
      if ($(this).text() == '--') {
        $(this).remove();
      }
    });
  }

  initializeStateInputInJquery(): void {
    let stateElem = this.stateElem.nativeElement;
    if ($('#state').attr('type') == 'text') {
      $('input#state').removeClass('withValue');
      $('input#state').attr('required', 'required');
      $('input#state').change(function (this: any) {
        stateElem.value = $(this).val();
        if ($(this).val() == 'null' || $(this).val() == '') {
          $(this).removeClass('withValue');
        } else {
          $(this).addClass('withValue');
        }
      });
    }
  }

  initializeStateDropdown(): void {
    let lblValue = this.stateLblElem.nativeElement.innerText;
    const selectText = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER', [
      this.commonUtil.translateText(lblValue),
    ]);
    this.rendererObj.setProperty(this.stateErrorElem.nativeElement, 'innerText', selectText);
    this.rendererObj.removeClass(this.stateCntrElem.nativeElement, 'selectCntr');
  }

  selectTimeZone(tz: string): void {
    if (tz && !this._manualCountryChange) {
      this.selectedTimezone = tz;
      let timezoneExists =
        this.timezoneList.filter((i) => tz.toLowerCase().includes(i.timezone.toLowerCase())).length > 0 ? true : false;
      if (timezoneExists) {
        this.changeTimeZone();
        this.selectedTimezone = tz;
      } else {
        this.timezoneList.push({ name: escape(tz), timezone: tz });
        this.selectedTimezone = tz;
      }
    }
  }

  checkMandatoryFields(): boolean {
    let facilityInfoFields = ['facilityName', 'facilityType', 'selectedCountryCode', 'selectedTimezone', 'phoneNumber'];
    this.facilityInfoErrors = {};
    for (let item of facilityInfoFields) {
      if (!(this as any)[item] || (this as any)[item].trim() === '' || (this as any)[item] == 'null') {
        this.facilityInfoErrors[item] = true;
      } else if (item == 'phoneNumber') {
        let phoneValidate = new RegExp('^(?=.*?[1-9])[0-9()+-.]+$');
        if (!phoneValidate.test(this[item])) {
          this.facilityInfoErrors[item] = true;
        }
      }
    }

    let facilityAddressFields = ['addressElem', 'cityElem', 'zipElem'];
    for (let addritem of facilityAddressFields) {
      if (
        (this as any)[addritem].nativeElement.style.display !== 'none' &&
        ((this as any)[addritem].nativeElement.value.trim() === '' ||
          (this as any)[addritem].nativeElement.value === 'null')
      ) {
        let facAddressFieldName = addritem.toString().substr(0, addritem.toString().length - 4);
        this.facilityInfoErrors[facAddressFieldName] = true;
      } else if (
        (this as any)[addritem].nativeElement.style.display !== 'none' &&
        addritem == 'zipElem' &&
        (this as any).zipFormat !== ''
      ) {
        let zipValidate = new RegExp(this.zipFormat);
        if (!zipValidate.test(this[addritem].nativeElement.value)) {
          let facAddressFieldName = addritem.toString().substr(0, addritem.toString().length - 4);
          this.facilityInfoErrors[facAddressFieldName] = true;
        }
      }
    }

    if (
      this.checkStateInJquery() &&
      (this.getStateValueInJquery().trim() === '' || this.getStateValueInJquery() === 'null')
    ) {
      this.facilityInfoErrors['state'] = true;
    }

    // time validate
    if (this.isFacilityForm && this.operationHoursValidation()) {
      this.facilityInfoErrors['operationHours'] = true;
    }

    setTimeout(() => {
      const errorElem = Object.keys(this.facilityInfoErrors).find(n => this.facilityInfoErrors[n] == true);
      if(errorElem) (document.getElementsByClassName('errorField')[0] as HTMLElement)?.focus();
    });

    if (!this.commonUtil.isEmpty(this.facilityInfoErrors)) {
      return false;
    }
    return true;
  }

  validateAddressAgainstGoogle(): void {
    const addressEntered = {
      locale: 'en_US',
      addressStatus: 4,
      facilityAddress: this.addressElem.nativeElement.value,
      state: this.getStateInJquery(),
      city: this.cityElem.nativeElement.value,
      country: this.countryName,
      postalCode: this.zipElem.nativeElement.value,
    };
    this.initialAddress = {
      locale: 'en_US',
      addressStatus: 4,
      address: this.addressElem.nativeElement.value,
      state: this.getStateInJquery(),
      city: this.cityElem.nativeElement.value,
      country: this.countryName,
      countryIsoCode: this.selectedCountryCode,
      postalCode: this.zipElem.nativeElement.value,
    };
    /*this.addressSample = {
      countryIsoCode: 'US',
      city: 'Santa Barbara',
      state: 'California',
      postalCode: '93101',
      facilityAddress: '27 East Cota Street',
      formattedFullAddress: '27 East Cota Street, Santa Barbara, California, US, 93101'
    }
    this.addressSample = {
      "addressStatus":2,
      "suggestedAddress":[
        {
          countryIsoCode: 'US',
          city: 'Santa Barbara',
          state: 'California',
          postalCode: '93101',
          facilityAddress: '27 East Cota Street',
          formattedFullAddress: '27 East Cota Street, Santa Barbara, California, US, 93101'
        },
        {
          countryIsoCode: 'US',
          city: 'Santa Barbara2',
          state: 'Albama',
          postalCode: '93102',
          facilityAddress: '28 East Cota Street',
          formattedFullAddress: '28 East Cota Street, Santa Barbara2, Albama, US, 93102'
        }
      ]
    }*/
    this.addressToMap = this.addressElem.nativeElement.value + ', ';
    if (this.cityElem.nativeElement.style.display != 'none') {
      this.addressToMap += this.cityElem.nativeElement.value + ', ';
    }
    if (this.checkStateInJquery()) {
      this.addressToMap += this.getStateInJquery() + ', ';
    }
    let selectedCountryCode = this.selectedCountryCode;
    this.addressToMap += this.countryName;
    if (this.zipElem.nativeElement.style.display != 'none') {
      this.addressToMap += ', ' + this.zipElem.nativeElement.value;
    }
    if (!this.hasEditFacPerm) {
      this.emitStep2FieldValuesToParentComponent();
    } else {
      //this.passAddressToForm(this.addressSample);
      this.googleAddressValidateService.validateAddressAgainstGoogle(addressEntered).subscribe((data) => {
        //let data = this.addressSample;
        if (typeof data.suggestedAddress != 'undefined') this.googleAddressSuggestions = data.suggestedAddress;
        this.googleValidatedAddressStatus = data.addressStatus;
        if (this.googleValidatedAddressStatus == 1) {
          this.isAddreesApprovedByUser = true;
          this.emitStep2FieldValuesToParentComponent();
        } else if (this.googleValidatedAddressStatus == 2 && this.isAddreesApprovedByUser && this.hasEditFacPerm) {
          this.emitStep2FieldValuesToParentComponent();
        } else if (this.googleValidatedAddressStatus == 2 && !this.isAddreesApprovedByUser) {
          this.scrollToError();
        }
      });
    }
  }

  scrollToError(): void {
    const elmnt = <HTMLElement>document.getElementById('addressErrorCntr');
    elmnt.scrollIntoView({ behavior: 'smooth' });
  }

  getStateInJquery(): string {
    if ($('#state').css('display') != 'none') {
      let stateVal = $('#state').attr('type') == 'text' ? $('#state').val() : $('#state option:selected').text();
      return stateVal;
    }
    return '';
  }

  checkStateInJquery(): boolean {
    if ($('#state').css('display') != 'none') {
      return true;
    }
    return false;
  }

  getStateValueInJquery(): string {
    if ($('#state').css('display') != 'none') {
      let stateVal = $('#state').attr('type') == 'text' ? $('#state').val() : $('#state option:selected').val();
      return stateVal;
    }
    return '';
  }

  populateStateInJquery(state: string): void {
    if (!$('#state').is('select')) {
      $('#state').val(state);
    } else {
      let facility_state: string = '';
      $('#state option').each(function (this: any) {
        let curStateObj = $(this);
        if (curStateObj.text() == state) {
          facility_state = curStateObj.val();
        }
      });
      if (facility_state) {
        $('select#state').val(facility_state);
      } else {
        if (!this._manualCountryChange) {
          var newOption: any = <HTMLElement>document.createElement('option');
          newOption.text = state;
          newOption.setAttribute('value', escape(state));
          newOption.setAttribute('selected', 'selected');
          $('select#state').append(newOption);
        }
      }
      $('select#state').addClass('withValue');
    }
    $('#state').attr('disabled', !this.hasEditFacPerm);
  }

  populateOtherAddressFields(address: any): void {
    if (address.city) this.rendererObj.setProperty(this.cityElem.nativeElement, 'value', address.city);
    if (address.postalCode) this.rendererObj.setProperty(this.zipElem.nativeElement, 'value', address.postalCode);
    if (address.address) this.rendererObj.setProperty(this.addressElem.nativeElement, 'value', address.address);
  }

  passAddressToForm(address: any): void {
    this.addressToMap = address.formattedFullAddress;
    this.isAddressConfirmed = true;
    this.isAddreesApprovedByUser = true;
    if (this.selectedCountryCode !== address.countryIsoCode) {
      this.selectedCountryCode = address.countryIsoCode;
      this.populateTimezone(address.countryIsoCode, false);
    }
    this.rendererObj.setProperty(this.cityElem.nativeElement, 'value', address.city);
    this.populateStateInJquery(address.state);
    this.rendererObj.setProperty(this.zipElem.nativeElement, 'value', address.postalCode);
    this.rendererObj.setProperty(this.addressElem.nativeElement, 'value', address.facilityAddress);
  }

  fillTheFormWithOldValues(): void {
    this.isAddressConfirmed = false;
    this.isAddreesApprovedByUser = true;
    if (this.selectedCountryCode !== this.initialAddress.countryIsoCode) {
      this.selectedCountryCode = this.initialAddress.countryIsoCode;
      this.populateTimezone(this.initialAddress.countryIsoCode, false);
    }
    this.rendererObj.setProperty(this.cityElem.nativeElement, 'value', this.initialAddress.city);
    this.rendererObj.setProperty(this.zipElem.nativeElement, 'value', this.initialAddress.postalCode);
    this.rendererObj.setProperty(this.addressElem.nativeElement, 'value', this.initialAddress.address);
    this.addressToMap =
      this.initialAddress.city +
      ', ' +
      this.initialAddress.state +
      ', ' +
      this.initialAddress.postalCode +
      ', ' +
      this.initialAddress.countryName;
    //	trackEvent(gaConstants.category.SignupManager, gaConstants.action.SelectSuggestedAddress, gaConstants.label.False);*/
    setTimeout(() => {
      this.populateStateInJquery(this.initialAddress.state);
    }, 300);
  }

  setAsValidAddress(): void {
    this.isAddreesApprovedByUser = true;
    this.googleValidatedAddressStatus = 0;
    this.isAddressConfirmed = false;
    let state_val = this.getStateInJquery();
    this.addressToMap =
      this.cityElem.nativeElement.value +
      ', ' +
      state_val +
      ', ' +
      this.zipElem.nativeElement.value +
      ', ' +
      this.countryName;
    // trackEvent(gaConstants.category.SignupManager, gaConstants.action.AddressConfirmation, gaConstants.label.True);
  }
  setAsInvalidAddress(): void {
    this.isAddreesApprovedByUser = false;
    this.googleValidatedAddressStatus = 0;
    // trackEvent(gaConstants.category.SignupManager, gaConstants.action.AddressConfirmation, gaConstants.label.False);
  }

  gotoStep1(): void {
    this.backBtnClickOnStep2.emit();
  }

  gotoStep3(): boolean {
    if (this.hasEditFacPerm && !this.checkMandatoryFields()) {
      return false;
    } else {
      this.validateAddressAgainstGoogle();
      return true;
    }
  }

  emitStep2FieldValuesToParentComponent(): void {
    const step2Data: IStep2Data = {
      facility: {
        facilityName: this.facilityName,
        phoneNumber: this.phoneNumber,
        timezone: this.selectedTimezone,
        facilityType: this.facilityType,
        address: this.addressElem.nativeElement.value,
        city: this.cityElem.nativeElement.value,
        state: this.getStateInJquery(),
        postalCode: this.zipElem.nativeElement.value,
        countryId: this.countryId,
        addressStatus: '3',
        isConnected: this.isConnected,
        displayTimezone: this.displayTimezone,
        countryName: this.countryName,
        displayFacilityType: this.displayFacilityType,
      },
    };

    // facility add / edit
    step2Data.facility.facilityHoursStart = this.facilityInformation?.facilityHoursStart ?? ('0' + this.openTime.split(':')[0]).slice(-2);
    step2Data.facility.facilityMinsStart = this.facilityInformation?.facilityMinsStart ?? ('0' + this.openTime.split(':')[1]).slice(-2);
    step2Data.facility.facilityHoursEnd = this.facilityInformation?.facilityHoursEnd ?? ('0' + this.closeTime.split(':')[0]).slice(-2);
    step2Data.facility.facilityMinsEnd = this.facilityInformation?.facilityMinsEnd ?? ('0' + this.closeTime.split(':')[1]).slice(-2);

    if (this.facilityId) {
      step2Data.facility.facilityId = this.facilityId;
    }
    this.step2Values.emit(step2Data);
    this.googleValidatedAddressStatus = 0;
    this.isAddreesApprovedByUser = false;
    this.nextBtnClickOnStep2.emit();
  }

  cancelSignup(): void {
    this.cancelBtnClickOnStep2.emit();
  }

  // facility add / edit

  initFacilityForm() {
    if (!this.isFacilityForm) {
      return;
    }
    this.iAccept = true;
    this.openFacTime = { facilityHours: 24, facilityMins: 0 };
    this.closeFacTime = { facilityHours: 23, facilityMins: 59 };

    if (this.action == 'edit') {
      this.setDeleteFacilityPopupData();
      const _selectedFacility = this._facilityService.selectedFacility();
      this.facilityId = parseInt(_selectedFacility.facilityId, 10);
      this.facilityName = _selectedFacility.facilityName;

      if (_selectedFacility.summary.facilityHoursEnd == '24') {
        this.openTime = `24:00`;
        this.closeTime = `00:00`;
        this.openFacTime = {
          facilityHours: parseInt(_selectedFacility.summary.facilityHoursStart),
          facilityMins: parseInt(_selectedFacility.summary.facilityMinsStart),
        };
        setTimeout(() => {
          this.getCurrentOpenTime('99:99');
        }, 300);
      } else {
        this.openFacTime = {
          facilityHours: parseInt(_selectedFacility.summary.facilityHoursStart, 10),
          facilityMins: parseInt(_selectedFacility.summary.facilityMinsStart, 10),
        };
        this.closeFacTime = {
          facilityHours: parseInt(_selectedFacility.summary.facilityHoursEnd, 10),
          facilityMins: parseInt(_selectedFacility.summary.facilityMinsEnd, 10),
        };
        this.openTime = `${this.openFacTime.facilityHours}:${this.openFacTime.facilityMins}`;
        this.closeTime = `${this.closeFacTime.facilityHours}:${this.closeFacTime.facilityMins}`;
      }

      this.initialAddress = {
        locale: 'en_US',
        addressStatus: _selectedFacility.summary.addressStatus,
        address: _selectedFacility.summary.address,
        state: _selectedFacility.summary.state,
        city: _selectedFacility.summary.city,
        country: _selectedFacility.summary.countryName,
        countryIsoCode: _selectedFacility.summary.countryIsoCode,
        postalCode: _selectedFacility.summary.postalCode,
      };

      this.facilityInformation = {
        facilityName: _selectedFacility.facilityName,
        ipAddress: _selectedFacility.ipAddress,
        facilityId: _selectedFacility.facilityId,
        facilityType: _selectedFacility.summary.facilityType,
        phoneNumber: _selectedFacility.summary.phoneNumber,
        countryIsoCode: _selectedFacility.summary.countryIsoCode,
        timezone: _selectedFacility.summary.timezone,
        isConnected: _selectedFacility.summary.isConnected === 'true' ? true : false,
        userRights: {
          facility: _selectedFacility.summary.userRights.facility,
        },
        facilityRights:{
          lfodEnabledEquipment: _selectedFacility.summary.facilityRights.lfodEnabledEquipment === 'true' ? true : false,
          digitalCoach: _selectedFacility.summary.facilityRights.digitalCoach === 'true' ? true : false,
          membersChallenges: _selectedFacility.summary.facilityRights.membersChallenges === 'true' ? true : false, 
          membersManage: _selectedFacility.summary.facilityRights.membersManage === 'true' ? true : false,
          membersMenu: _selectedFacility.summary.facilityRights.membersMenu === 'true' ? true : false,
          membersPromote: _selectedFacility.summary.facilityRights.membersPromote === 'true' ? true : false, 
          membersRetention: _selectedFacility.summary.facilityRights.membersRetention === 'true' ? true : false,
          videoLibrary: _selectedFacility.summary.facilityRights.videoLibrary === 'true' ? true : false,
        }

      };
      if (_selectedFacility.summary.state) {
        this.facilityInformation['state'] = _selectedFacility.summary.state;
      }
      this.checkPrepopulateFacilityInfo();
      // isOneFacilityManager is to check whether the user has only one facility/
      // isConnected Falg is especially for checking equipment was connected or not.
      // To allow user to see delete facility button , facility should not be connected and shouldn't have any subscription.if non connected facility , user must be solo user to see delete facility button.
      let isConnectedEquipmentNSubScription = false;
      let isOnlyOneFacilityManager = this._facilityService.isOneFacilityManager();
      let isLoggedInManagerAdmin = _selectedFacility.summary.isLoggedInManagerAdmin;
      let multiFac = this.multiFacService.getFacility(_selectedFacility.facilityId);
      let isMultiFacility = (multiFac && (multiFac.parentId || multiFac.children?.length > 0))?true:false;
      if(this.facilityInformation.isConnected ||
        this.facilityInformation.facilityRights.lfodEnabledEquipment ||
        this.facilityInformation.facilityRights.digitalCoach ||
        this.facilityInformation.facilityRights.membersChallenges ||
        this.facilityInformation.facilityRights.membersManage ||
        this.facilityInformation.facilityRights.membersMenu ||
        this.facilityInformation.facilityRights.membersPromote ||
        this.facilityInformation.facilityRights.membersRetention ||
        this.facilityInformation.facilityRights.videoLibrary){
          isConnectedEquipmentNSubScription = true;
      }



       if(!isConnectedEquipmentNSubScription && !isOnlyOneFacilityManager  && !isMultiFacility){
        this.isDeleteAvailable = true;
      }

      setTimeout(() => {
        this.rendererObj.setProperty(this.addressElem.nativeElement, 'value', _selectedFacility.summary.address);
        this.rendererObj.setProperty(this.cityElem.nativeElement, 'value', _selectedFacility.summary.city);
        this.rendererObj.setProperty(this.stateElem.nativeElement, 'value', _selectedFacility.summary.state);
        this.rendererObj.setProperty(this.zipElem.nativeElement, 'value', _selectedFacility.summary.postalCode);
        this.rendererObj.setProperty(this.cityElem.nativeElement, 'value', _selectedFacility.summary.city);
        this.fillTheFormWithOldValues();
        this.isAddreesApprovedByUser = false;
        this.populateStateInJquery(_selectedFacility.summary.state);
      }, 500);
    } else {
      if (this.rootScopeData.deviceType === 'phone') {
        setTimeout(() => {
          this.getCurrentOpenTime('99:99');
        }, 300);
      }
    }

    var that = this;
    $('input').each(function(this:any) {
      $(this).on('input', function() {
        that.rootScopeData.isPageHasUnsavedChanges = true;
      });
    });
  }

  isAfter24Hr: boolean = false;
  getCurrentOpenTime(time: string) {
    if (time === '99:99') {
      this.openTime = '00:00';
      this.closeTime = '24:00';
      this.openTimeDisableController = 'mp';
      this.closeTimeDisableController = 'hmp';
      this.isAfter24Hr = true;
      if (this.isClickedOnCloseTime) {
        this.isClickedOnCloseTime = false;
        this.closeFacTime = { facilityHours: 23, facilityMins: 59 };
      }
    } else {
      this.openTime = time;
      if (!this.isClickedOnCloseTime) {
        this.closeTime = '23:59';
      }
      if (this.rootScopeData.deviceType === 'phone' && this.isAfter24Hr) {
        this.openFacTime = { facilityHours: 0, facilityMins: 0 };
        this.closeFacTime = { facilityHours: 23, facilityMins: 59 };
        this.isAfter24Hr = true;
      } else {
        if (this.action == 'edit') {
          this.closeTime = `${this.closeFacTime.facilityHours}:${this.closeFacTime.facilityMins}`;
        }
      }
      this.openTimeDisableController = '';
      this.closeTimeDisableController = '';
    }
    this.operationHoursValidation();
  }

  getCurrentCloseTime(time: string) {
    this.closeFacTime.facilityHours = parseInt(time.toString().split(':')[0]);
    this.closeFacTime.facilityMins = parseInt(time.toString().split(':')[1]);
    this.isClickedOnCloseTime = true;
    this.closeTime = time;
    this.operationHoursValidation();
  }

  operationHoursValidation() {
    this.facilityOperationHourBefore = false;
    this.facilityOperationHourSame = false;

    let _closeH = parseInt(this.closeTime ? this.closeTime.split(':')[0] : '0', 10),
      _closeM = parseInt(this.closeTime ? this.closeTime.split(':')[1] : '0', 10),
      _openH = parseInt(this.openTime ? this.openTime.split(':')[0] : '0', 10),
      _openM = parseInt(this.openTime ? this.openTime.split(':')[1] : '0', 10);

    if (_openH == _closeH) {
      if (_openM == _closeM) {
        this.facilityOperationHourSame = true;
      } else if (_openM > _closeM) {
        this.facilityOperationHourBefore = true;
      }
    } else if (_openH > _closeH) {
      this.facilityOperationHourBefore = true;
    }

    return this.facilityOperationHourBefore || this.facilityOperationHourSame;
  }

  deleteFacility() {
    // has been deleted successfully!
    this.showDeleteFacilityModal = true;
  }

  setDeleteFacilityPopupData() {
    // const assetCount: string = JSON.stringify(this.onDemandData.outdatedAssetCount);
    this.deleteFacilityPopupProperties = {
      title: 'DELETE.FACILITY',
      message: 'DELETE.MODAL.MESSAGE',
      isWarningPopup: true,
      ctaButtonLabel: 'DELETE',
      negativeButtonLabel: 'CANCEL',
      isCloseIconCallsCta: false,
      isSecondaryTextButton: true,
    };
  }

  deleteFacilityModalConfirmDelete(event: any) {
    if (this.isDeleteMultiFacility) {
      this.router.navigate(['/facility/manage']);
      this.isDeleteMultiFacility = false;
    } else {
      this.loader.startProcess();
      this._facilityService.remove(this.facilityId.toString()).then(
        (res: any) => {
          this.toast.creatToast(
            this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETED.SUCCESS.MSG', [this.facilityName]),
            EToastType.SUCCESS
          );
          this.router.navigate(['/facility/manage']);
          this.loader.endProcess();
        },
        (err: any) => {
          // this.toast.creatToast('Error', EToastType.ERROR);
          let errorTitle = err['error'].title;

          if (errorTitle === 'multisite-facility') {
            this.errorFacilityPopupProperties = {
              title: 'DELETE.FACILITY',
              message: 'DELETE.MULTIFACILITY.MODAL.MESSAGE',
              isWarningPopup: true,
              ctaButtonLabel: 'OK',
              isCloseIconCallsCta: true,
              hideSecondaryButton: true,
            };
            this.isDeleteMultiFacility = true;
          } else if(errorTitle ==='another-single-admin-facility') {
            this.errorFacilityPopupProperties = {
              title: 'UNABLE.TO.PROCEED',
              message: 'DELETE.FACILITY.DELETE.SINGLE.ERRPOR',
              isWarningPopup: true,
              ctaButtonLabel: 'OK',
              isCloseIconCallsCta: true,
              hideSecondaryButton: true,
            };
            this.showErrorFacilityModal = true;
            this.showDeleteFacilityModal = false;
          } else {
            this.router.navigate(['/facility/manage']);
          }
          this.loader.endProcess();
        }
      );
    }
    // .finally(() => this.router.navigate(['/facility/manage']));
  }

  deleteFacilityModalCancel(event: any) {
    this.showDeleteFacilityModal = false;
    this.isDeleteMultiFacility = false;
  }

  errorFacilityModalClose(event: any) {
    this.showErrorFacilityModal = false;
  }
}

interface IStep2Data {
  facility: {
    facilityName: string;
    phoneNumber: string;
    timezone: string;
    facilityType: string;
    address: string;
    city: string;
    state: string;
    postalCode: string;
    countryId: string;
    addressStatus: string;
    isConnected: boolean;
    displayTimezone: string;
    countryName: string;
    displayFacilityType: string;
    facilityId?: number;
    facilityHoursStart?: string;
    facilityMinsStart?: string;
    facilityHoursEnd?: string;
    facilityMinsEnd?: string;
  };
}
